import script from "./AssetTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetTableItem.vue?vue&type=script&setup=true&lang=js"

import "./AssetTableItem.vue?vue&type=style&index=0&id=1aa31cf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa31cf8"]])

export default __exports__